import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import { Provider } from 'react-redux';
import {createStore , applyMiddleware ,compose}  from 'redux' ;
import thunk from 'redux-thunk';
import reducers from './reducers';

//  dev tools compose so we can use it with tunk and other enhancers & middlewares
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store =  createStore(reducers,composeEnhancer(applyMiddleware(thunk)));  //redux store to store the state


ReactDOM.render(<Provider store={store} ><App /></Provider> ,  document.getElementById('root'));

